<!-- <div class="flex align-items-center justify-content-center input">{{ appSettings.translate[appSettings.selectedLang]['dates_filter'] }}:</div> -->
<div class="flex align-items-center justify-content-center">
  <div class="p-inputgroup">
    <p-calendar
      *ngIf="showDate"
      [(ngModel)]="rangeDates"
      selectionMode="range"
      [readonlyInput]="false"
      (onSelect)="loadData()"
      dateFormat="dd.mm.yy"
      [touchUI]="false"
      [showIcon]="false"
      [keepInvalid]="true"
      [firstDayOfWeek]="1"
      [focusTrap]="false"
      #calendarInput
    ></p-calendar>
    <button
      type="button"
      pButton
      pRipple
      icon="pi pi-refresh"
      styleClass="p-button-warn"
      (click)="loadData()"
    ></button>
    <button
      *ngIf="showDate"
      type="button"
      pButton
      pRipple
      icon="pi pi-check-square"
      styleClass="p-button-warn"
      (click)="goToCurrentDay()"
      [pTooltip]="
        appSettings.translate[appSettings.selectedLang]['current_day']
      "
    ></button>
  </div>
</div>
